import qs from "querystring"

import { httpClient } from "utils/infrastructure/httpClient"

interface Price {
    price: number
    price_usd: number
}

function createGetPrice() {
    const cache = new Map<string, Promise<Price> | Price>()
    function cacheKey(bookingId: number, discount: number | undefined) {
        return `${bookingId} ${discount ?? ""}`
    }
    function getServicePrice(bookingId: number, discount: number | undefined) {
        return httpClient.get<Price>(`booking/${bookingId}/get-price?${qs.stringify({ discount })}`)
    }
    function toResult(value: Promise<Price> | Price) {
        if (value instanceof Promise) return value
        return Promise.resolve(value)
    }
    return function wrapper(bookingId: number, discount: number | undefined): Promise<Price> {
        const key = cacheKey(bookingId, discount)
        const value = cache.get(key)
        if (value) {
            return toResult(value)
        } else {
            const request = getServicePrice(bookingId, discount).then((data) => {
                cache.set(key, data)
                return data
            })
            cache.set(key, request)
            return toResult(request)
        }
    }
}

export const getPrice = createGetPrice()
